var userdata = function (filename) {
    try {
        var input = document.createElement("INPUT");
        input.type = "hidden";
        input.style.display = "none";
        input.addBehavior("#default#userData");
        document.body.appendChild(input);

        var expires = new Date();
        expires.setDate(expires.getDate() + 365);
        input.expires = expires.toUTCString();

        return {
            load: function () {
                try {
                    input.load(filename);
                }
                catch (e) {
                    console.error('userdata.load:' + e.message + '   filename:' + JSON.stringify(filename));
                }
            },
            save: function () {
                try {
                    input.save(filename);
                }
                catch (e) {
                    console.error('userdata.save:' + e.message + '   filename:' + JSON.stringify(filename));
                }
            },
            getAttribute: function (name) {
                try {
                    return input.getAttribute(name);
                }
                catch (e) {
                    console.error('userdata.getAttribute:' + e.message + '   filename:' + JSON.stringify(filename));
                }
            },
            setAttribute: function (name, value) {
                try {
                    input.setAttribute(name, value);
                }
                catch (e) {
                    console.error('userdata.setAttribute:' + e.message + '   filename:' + JSON.stringify(filename));
                }
            },
            removeAttribute: function (name) {
                try {
                    input.removeAttribute(name);
                }
                catch (e) {
                    console.error('userdata.removeAttribute:' + e.message + '   filename:' + JSON.stringify(filename));
                }
            },
            clear: function () {
                try {
                    var expires = new Date();
                    expires.setMinutes(expires.getMinutes() - 1);
                    input.expires = expires.toUTCString();
                    this.save();
                }
                catch (e) {
                    console.error('userdata.clear:' + e.message + '   filename:' + JSON.stringify(filename));
                }
            }
        };
    } catch (e) {
        console.error('init userdata:' + e.message);
        return null;
    }
};

/*
 setTimeout(function(){
 var test=userdata('test');
 test.load();
 test.setAttribute('qw', '9999');
 test.save();
 }, 1000);

 setTimeout(function(){
 var test=userdata('test');
 test.removeAttribute('qw');
 test.save();
 console.error('clear');
 }, 5000);

 setTimeout(function(){
 var test=userdata('test');
 test.load();
 console.error(test.getAttribute('qw'));
 },10000);*/


module.exports = userdata;
